import * as React from "react";

export default class GuestLayout extends React.Component {
    render() {
        return <div id="guestLayout" className="layout">
                <div className="container container-content">
                    {this.props.children}
                </div>
            </div>;
    }
}